// src/app/shared/loading-overlay.component.ts
import { Component, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from 'src/app/_services/loading.service';

@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="isVisible()" class="overlay">
      <div class="spinner"></div>
    </div>
  `,
  styles: [`
    .overlay {
      position: fixed;
      top: 0; left: 0;
      width: 100vw; height: 100vh;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .spinner {
      width: 60px;
      height: 60px;
      border: 8px solid #f3f3f3;
      border-top: 8px solid rgb(18, 129, 14);;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `]
})
export class LoadingOverlayComponent {
  isVisible = computed(() => this.loadingService.loading());

  constructor(private loadingService: LoadingService) {}
}
